import React from "react";
import "./index.scss";
import { useTranslationContext } from "../../context/TranslationContext";
import { useSelector, useDispatch } from "react-redux";
import { useQuery } from "react-query";
import { getlanguageAPI } from "../../services/api";
import { setLanguageIntial } from "../../store/language.slice";
import { languageList } from "../../utils/localstore";
import { useTranslation } from "react-i18next";

const TermsAndConditions = ({ setSelectedSection }) => {
  const dispatch = useDispatch();
  const lnFromStore = useSelector((state) => state.language);
  const { i18n } = useTranslation();
  const i18Language = i18n.language.split('-')[0]
    const language =  languageList.includes(i18Language) ? i18Language : 'en'

  let { isLoading } = useQuery(
    ["policyTerms", language],
    getlanguageAPI.bind(null, language, "policyTerms"),
    {
      enabled: !lnFromStore[language],
      onSuccess: (o) => dispatch(setLanguageIntial({ k: language, v: o })),
    }
  );
  const { labelsIot } = useTranslationContext();
  const policyTerms = useSelector(
    (state) => state.language?.activelang?.policyTerms
  );
  const termsAndConditions = !!policyTerms?.termsAndConditions
    ? JSON.parse(policyTerms.termsAndConditions)
    : {};

  return (
    <>
      <div className="add-device">
        <p
          className="backto-button"
          onClick={() => setSelectedSection("settings")}
        >
          <i className="pi pi-arrow-left pr-2"></i> {labelsIot?.LBLI0140}
        </p>
        {isLoading ? (
          <div className="full-window-loading payment-loading">
            <i className="pi pi-spin pi-spinner"></i>
            <h2 color="white" style={{ color: "white" }}>
              {labelsIot?.LBLI0139}
            </h2>
          </div>
        ) : (
          <>
            <div className="content-header flex align-items-center justify-content-between">
              <h1>{termsAndConditions.title}</h1>
            </div>
            <div className="content-section">
              <div className="grid grid-nogutter w-12">
                <div className="col-12 md:col-12">
                  <div
                    dangerouslySetInnerHTML={{
                      __html: termsAndConditions.description,
                    }}
                  ></div>
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default TermsAndConditions;
